module.exports = __webpack_public_path__ + "assets/img/18.2455a210.png";